import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Alert,
  IconButton,
} from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import {
  fonts,
  getStartedModalCloseIcon,
  getStartedModalStyles,
  getStartedSmallButtons,
  getStartedTexts,
  headingFonts,
  mainButtonStyles,
  textFieldStyles,
} from "../../Styles/Styles";

export default function ForgotPasswordForm({ onClose }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/user/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setMessage(
          "If an account with that email exists, a reset link has been sent."
        );
      } else {
        setError(data.message || "An error occurred.");
      }
    } catch (err) {
      setError("Error sending reset email. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ ...getStartedModalStyles }}>
      {/* Close Button */}
      <IconButton
        onClick={() => onClose("login")}
        sx={{ ...getStartedModalCloseIcon }}
      >
        <CancelOutlinedIcon />
      </IconButton>

      <Typography
        variant="h5"
        fontWeight="bold"
        sx={{
          ...headingFonts,
          color: "var(--secondary-color)",
          mb: 1,
        }}
      >
        Forgot Password?
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ ...headingFonts, mb: 2 }}
      >
        Enter your email, and we'll send you a password reset link.
      </Typography>

      <form onSubmit={handleForgotPassword} style={{ width: "100%" }}>
        <TextField
          label="Email Address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          required
          margin="normal"
          variant="outlined"
          sx={{ ...textFieldStyles }}
        />

        <Button
          type="submit"
          className="main-button-style"
          sx={{ mt: 2, ...mainButtonStyles }}
          disabled={loading}
        >
          {loading ? (
            <>
              <span>Sending...</span>
              <CircularProgress size={20} sx={{ color: "white" }} />
            </>
          ) : (
            <>
              <span>Send Reset Link</span>
              <ArrowForwardOutlinedIcon />
            </>
          )}
        </Button>
      </form>

      {message && (
        <Alert severity="success" sx={{ ...fonts, mt: 2, width: "100%" }}>
          {message}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ ...fonts, mt: 2, width: "100%" }}>
          {error}
        </Alert>
      )}

      <Typography variant="body2" sx={{ mt: 2, ...getStartedTexts }}>
        Remembered your password?{" "}
        <Button
          size="small"
          sx={{ ...getStartedSmallButtons }}
          onClick={() => onClose("login")}
        >
          Log In
        </Button>
      </Typography>
    </Box>
  );
}
